import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ADDITIONAL_SERVICES } from './winterLogOptions';

/**
 * Site Check and Salt Bin Refill as their own check-off items (TKT-486).
 * Used in Crew Mode's Clock In / Clock Out box and in the winter log.
 * `value` is the list of codes saved in snow_services_performed.additional_services.
 */
const WinterAdditionalServices = ({ value = [], onChange, disabled = false }) => {
  const { t } = useTranslation();
  const selected = Array.isArray(value) ? value : [];

  const toggle = (code) => (event) => {
    const rest = selected.filter((c) => c !== code);
    onChange(event.target.checked ? [...rest, code] : rest);
  };

  return (
    <FormGroup>
      {ADDITIONAL_SERVICES.map((option) => {
        const label = t(`winterLogs.${option.label}`);
        return (
          <FormControlLabel
            key={option.code}
            control={(
              <Checkbox
                checked={selected.includes(option.code)}
                onChange={toggle(option.code)}
                disabled={disabled}
                size="large"
                inputProps={{ 'aria-label': label }}
              />
            )}
            label={label}
            sx={{ mb: 1, display: 'flex' }}
          />
        );
      })}
    </FormGroup>
  );
};

export default WinterAdditionalServices;
